import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent{
    @ViewChild("dialog")
    private dialog: ElementRef;
  constructor(private host: ElementRef) {}


  show() {
      this.element.showModal();
  }

  hide() {
      this.element.close();
  }


  private get element() {
    return this.dialog.nativeElement;
  }
}
